import { css } from "styled-components/macro";

export const HeaderAction = css`
  padding: 2px 4px;
  border: 1px solid transparent;

  &:hover,
  &:active {
    border: 1px solid grey;
  }
`;
